import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformServer } from "@angular/common";

export interface IYoutube {
  url?: string;
  icon?: string;
  label?: string;
}

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  private apiVideo: string;
  private apiShorts: string;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // SSR/prerender: Node.js cannot resolve relative URLs — use absolute API host.
    // Browser: use relative path so the Angular dev proxy (proxy.config.json) and
    //          production Express proxy handle routing (avoids CORS entirely).
    if (isPlatformServer(this.platformId)) {
      this.apiVideo  = 'https://api.softnetcomputers.lk/api/youtube-videos/web';
      this.apiShorts = 'https://api.softnetcomputers.lk/api/youtube-shorts/web';
    } else {
      this.apiVideo  = '/api/youtube-videos/web';
      this.apiShorts = '/api/youtube-shorts/web';
    }
  }

  getVideos() {
    return this.http.get<IYoutube[]>(this.apiVideo);
  }

  getSHorts() {
    return this.http.get<IYoutube[]>(this.apiShorts);
  }
}